<template>
  <v-container fill-height
               fluid
               grid-list-xl>
    <v-layout justify-center
              wrap>

      <v-flex xs12 md12 lg10>
        <material-card :color="getTitleColorStore"
                       :title="$t('menu_guides')"
                       text="">

          <v-layout row wrap>
            <v-flex xs12 align-end flexbox text-xs-center>
              <v-btn color="red" @click="skiniFile(l.link, l.name)" v-for="l in links" :key="l.link" small>
                <v-icon large class="white--text">mdi-file-pdf</v-icon>
                <span class="white--text"> {{l.name}} </span>

              </v-btn>

            </v-flex>
          </v-layout>

          <a ref="aDownload" href="#" target="_blank"></a>

        </material-card>
      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Guides',
    computed: {
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),
      links: function () {
        return [
          { link: '/Dokumenti/vodic_za_polaznike_ucionica.pdf', name: this.$t('guides.link1') },
          { link: '/Dokumenti/vodic_za_polaznike_online.pdf', name: this.$t('guides.link2') },
          { link: '/Dokumenti/vodic_za_samostalno_ucenje.pdf', name: this.$t('guides.link3') },
          { link: '/Dokumenti/Univerzalni_zahtjev.pdf', name: this.$t('guides.link4') },
          { link: '/Dokumenti/eticki_kodeks.pdf', name: this.$t('guides.link5') },
        ]
      }
    },

    data() {
      return {
        fileUrl: '',

      }
    },

    methods: {
      async skiniFile(filePath, name) {
        var url = filePath;
        var self = this;
        var request = this.__fetchProps(null, 'GET', true);
        
        var result = await fetch(filePath, request)
          .then(res => res.blob())
          .then(function (res) {
            self.$downloadBlob(res, 'pdf', name);
          })
          .catch(error => {
            self.$displayError('Dogodila se greška, datoteku nije moguće preuzeti.')
          })
          .then(function () {
            
          });
      }
    }



  }
</script>



// WEBPACK FOOTER //
// VueSrc/Guides/Guides.vue